<template>
  <div class="flex w-full items-center gap-3 lg:w-auto">
    <VcSelect
      v-model="selectedCountry"
      :items="countryOptions"
      :name="props.formElement.key"
      :label="formElement.properties.label"
      :required="isRequired"
      text-field="label"
      value-field="value"
      placeholder="Location"
      class="form-country-dropdown_select w-full flex-1 text-base lg:w-[190px]"
      :message="message"
      :error="error"
      @change="(newValue) => validate(newValue)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useOptiCountries } from "@/core/composables/useOptiCountries";
import { FormValidator } from "../forms-sdk";
import type { ElementValidationResult } from "../forms-sdk";
import type { ExtendedFormElement } from "../types";

interface IProps {
  formElement: ExtendedFormElement;
  errorMessage?: ElementValidationResult;
}
const emit = defineEmits<IEmits>();
const props = defineProps<IProps>();
const selectedCountry = defineModel<string | undefined>();
const { countries } = useOptiCountries(false);
// country.name is used intentionally used as value because the form submission will use the label of the menu item
// This matters because if there are any conditions, they are evaluated both in the frontend and in the backend,
// frontend doing the comparison based on the value (this is available in form.vue), while the backend does it based on the label
const countryOptions = computed(() => countries.value.map((country) => ({ label: country.name, value: country.name })));

interface IEmits {
  (event: "update:error-message", error: ElementValidationResult): void;
}

const elementValidationResult = ref<ElementValidationResult>({ valid: true, message: "" });
const message = computed(() => elementValidationResult.value?.message || props.errorMessage?.message);
const error = computed(() => !!elementValidationResult.value?.message || !!props.errorMessage?.message);

const isRequired = computed(
  () => !!props.formElement.properties.validators.find((v) => v.type === "RequiredValidator"),
);

const formValidator = new FormValidator(props.formElement);

function validate(newCountryValue: string): void {
  elementValidationResult.value = formValidator.validate(newCountryValue);
  emit("update:error-message", elementValidationResult.value);
}
</script>

<style lang="scss">
.form-country-dropdown_select {
  .vc-menu-item::before {
    display: none;
  }

  .vc-menu-item {
    padding: 0 !important;
  }
}
</style>
